import { Serializers, SerializerValue } from "@megaron/serializers";

export const orderStatuses = ["awaiting", "cancelled", "inProgress", "suspended", "fulfilled"] as const;
export type OrderStatus = (typeof orderStatuses)[number];

export const orderTypes = ["order", "creditMemo"] as const;
export type OrderType = (typeof orderTypes)[number];

export const orderSortFields = [
  "number",
  "sellToName",
  "invoiceNumbers",
  "billToName",
  "orderDate",
  "createdAt",
  "updatedAt",
  "promisedDeliveryDate",
  "profit",
] as const;
export type OrderSortField = (typeof orderSortFields)[number];

export const orderFiltersSerializer = Serializers.object({
  page: Serializers.integer,
  searchText: Serializers.string,
  regions: Serializers.string.array(),
  status: Serializers.stringOneOf(...orderStatuses).array(),
  sort: Serializers.sortFilter(orderSortFields).asJsonString(),
  type: Serializers.stringOneOf(...orderTypes)
    .array()
    .asJsonString(),
  startDate: Serializers.month,
  endDate: Serializers.month,
}).partial();

export type OrderFilters = SerializerValue<typeof orderFiltersSerializer>;
